import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/free-solid-svg-icons";

const BulkActionBar = ({ selectedCount, onFlag }) => {
    if (!selectedCount) return null;
    return (
        <div className="bulk-action-bar">
            <span className="bulk-action-bar__count">{selectedCount} selected</span>
            <button className="button -primary -small" onClick={onFlag}>
                <FontAwesomeIcon icon={faFlag} /> Flag Selected
            </button>
        </div>
    );
};

export default BulkActionBar;
